import { render, staticRenderFns } from "./back-abroadorder.vue?vue&type=template&id=11b2dd62"
import script from "./back-abroadorder.vue?vue&type=script&lang=ts"
export * from "./back-abroadorder.vue?vue&type=script&lang=ts"
import style0 from "./back-abroadorder.vue?vue&type=style&index=0&id=11b2dd62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports